import React, { useCallback, useEffect, useState  } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CheckOutlined } from '@ant-design/icons';
import { Translate } from 'app/services';
import { ActionButton } from '../../../../common'; 
import { useAuthState } from '../../../../../hooks/auth';
import { trackScorm, openWindow } from '../../../../../ScormTracker/ScormTracker';
import { IS_HOYA_THEME } from 'app/branding';
import { Navigation, Routes } from 'app/navigation';
import { buildCoursePath } from 'app/utils/buildCoursePath';
import { useTranslations } from 'app/hooks/translations/useTranslations';
import { CourseUtils } from '../../../../../utils/';
import './styles.less';
import { PaperIcon } from '@nackle/paper';

export const LearningObjectItem = ( props ) => {
     
    const { locale } = useTranslations();
    const [ courseData ] = useState( props.courseData );
    const [ lessonData ] = useState( props.lessonData );
    const { claims: { family_name: lastName, given_name: firstName } } = useAuthState();
    const [ courseWindow, setCourseWindow ] = useState();

    const buildLaunchUrl = useCallback( ( path, localeCode ) => {
        
        console.log( 'Original Lesson URL: ' + path );
        
        let tempPath = path;
        let isRise = false;

        // Uncomment one of these to test with a course locally 
        //tempPath = 'http://localhost:3021/scorm/chameleon-12/index.html';
        //tempPath = 'http://localhost:3021/scorm/test-bourne-course/';   //1.2
        //tempPath = 'http://localhost:3021/scorm/golf1/shared/launchpage.html';
        //return tempPath = 'http://localhost:3021/scorm/mon-2004/index.html';
        
        // 2004 course
        //  tempPath = 'http://localhost:3021/scorm/chameleon-2004-4th-edition/index.html'; //2004 + cert
        //tempPath = 'http://localhost:3021/scorm/chameleon-2004-3rd-edition/index.html';
        
        //tempPath = 'http://localhost:3021/scorm/test-camelean-course/';
        //tempPath = 'http://localhost:3021/scorm/test-bourne-course/';
        //tempPath = 'http://localhost:3021/scorm/presentingwithimpact/index.html'; 
        
        // Rise 1.2
        //tempPath = 'http://localhost:3021/scorm/single-vision-rise/scormdriver/indexAPI.html';
        //tempPath = 'http://localhost:3021/scorm/rx-rise/scormdriver/indexAPI.html';
        //tempPath = 'http://localhost:3021/scorm/rise-hygine/scormdriver/indexAPI.html';

        if ( tempPath.indexOf( 'scormdriver' ) > -1 ) {
            isRise = true;
        }

        if ( isRise ) {
            const tempLocale = localeCode; // SAVE THIS, WILL BE USED LATER localeCode === 'en-US' ? 'USA' : localeCode;
            console.log( 'Using locale for Rise: ', tempLocale );
         
            const modPath = tempPath.replace( /(http(s?):|)(^|\/\/)(.*?\/)/g, '/' );
        
            const url = `https://${ window.location.hostname }${ modPath }?language=${ tempLocale }&theme=${ IS_HOYA_THEME ? 'hoya' : 'seiko' }`;
            console.log( 'Modified Lesson URL:' +  url );
            
            return url;
        } else {
            const tempLocale =  CourseUtils.localeToChameleonLanguage( localeCode ); // SAVE THIS, WILL BE USED LATER localeCode === 'en-US' ? 'USA' : localeCode;
            console.log( 'Using locale for Chameleon: ', tempLocale );
            
            const modPath = tempPath.replace( /(http(s?):|)(^|\/\/)(.*?\/)/g, '/' );
            
            const url = `https://${ window.location.hostname }${ modPath }?language=${ tempLocale }&theme=${ IS_HOYA_THEME ? 'hoya' : 'seiko' }`;
            console.log( 'Modified Lesson URL:' +  url );
            
            return url;
        }

 
        // if ( ScormChameleonUtils.isValidEntryPath( tempPath ) ) {
        //     let chameleonLocaleCode = CourseUtils.localeToChameleonLanguage( localeCode );
        //     chameleonLocaleCode = localeCode === 'en-US' ? 'USA' : localeCode;
        //     return ScormChameleonUtils.buildEntryPath( tempPath, { localeCode: chameleonLocaleCode } );
        // }
        // else 
        // {
        //     let localeCode2 = localeCode === 'en-US' ? 'USA' : localeCode;   
        //     return  ScormRiseUtils.buildEntryPath( tempPath, { localeCode: localeCode2 } );
        // }
    }, [] );

    const handleOnStartCouse = () => { 
        if ( lessonData.mimeType === 'video/mp4' ) {
            Navigation.push( Routes.VideoPlayer.buildPath( courseData.id, lessonData.id ) );
        } else {
            trackScorm( courseData, lessonData, `${ lastName }, ${ firstName }`, `${ firstName }${ lastName }` );
            const url =  buildLaunchUrl( buildCoursePath( lessonData.url ), locale );
            setCourseWindow( openWindow( url, props.onUpdate ) );
        }
    };

    const closeCourseWindow = useCallback( () => {
        if ( courseWindow ) {
            courseWindow.close();
        }
    }, [ courseWindow ] );

    useEffect( () => {
        window.addEventListener( 'beforeunload', closeCourseWindow );
        
        return () => {
          window.removeEventListener( 'beforeunload', closeCourseWindow );
        };
      }, [ closeCourseWindow ] );
    
    const rootClasses = classnames(
        'course-details-level-item',
        { 'animate': Boolean( props.animate ) },
        { [ props.className ]: Boolean( props.className ) },
        { locked: props.locked }
    );

    return (
        <div className={ rootClasses } style={ props.style }>
            <span className="course-details-level-item-label">
                { props.label }
            </span>

            <span className="course-details-level-item-divider" />

            <div className="course-details-status">
                { props.locked ?
                    <span className="course-details-level-item-status-icon-container primary">
                        <PaperIcon collection='ultimate' icon='Lock4' />
                    </span> :
                    props.isComplete ?
                        <span className="course-details-level-item-status-icon-container primary">
                            <CheckOutlined />
                        </span> : <></>
                
                }

                <ActionButton
                    className={ classnames( 'course-details-level-item-action-button learning-action', { locked: props.locked } ) }
                    important={ !props.isComplete }
                    onClick={ () => {
                        if ( props.locked ) {
                            return;
                        }
                        handleOnStartCouse();
                    } }
                >
                     
                     { props.locked ?
                        <Translate.Text value='learningObject.actions.locked'/> :
                        props.isComplete ?
                            <Translate.Text value="learningObject.actions.review" /> :
                            <Translate.Text value="learningObject.actions.launch" />
                    }
                </ActionButton>
            </div>
        </div>
    );
};

LearningObjectItem.defaultProps = {
    className: undefined,
    style: undefined,
    id: undefined,
    label: 'Unknown',
    isComplete: false,
    animate: true,
    onUpdate: undefined
};

LearningObjectItem.propTypes = {
    className: PropTypes.string, 
    style: PropTypes.object,
    label: PropTypes.string,
    isComplete: PropTypes.bool,
    animate: PropTypes.bool,
    locked: PropTypes.bool,
};
